import styled from "styled-components";
import { DARK_GRAY, DINGY_GRAY, GRAY, NEAR_WHITE } from "../../../config";

export const Container = styled.div<{ rowHeight: number; dataLength: number }>`
  width: 100%;
  height: ${({ rowHeight, dataLength }) => `calc((${rowHeight}px * ${dataLength}) + 130px);`};
`;

export const BodyRow = styled.div<{
  isEven: boolean;
  rowHeight: number;
  hasHover?: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-left: unset;
  border-left-color: transparent;
  background: ${({ isEven }) => (isEven ? DINGY_GRAY : GRAY)};
  box-shadow: none;
  box-sizing: border-box;
  max-width: 100%;
  overflow: unset !important;
  transition: all 0.2s ease, background-color 0s, border-width 0s, padding 0s;

  .tooltip-container {
    display: none;
  }

  &:hover {
    .tooltip-container {
      display: flex;
    }

    -webkit-box-shadow: 0px 0px 2px 0px ${({ isEven }) => (isEven ? DINGY_GRAY : GRAY)},
      0px 0px 2px 2px ${({ isEven }) => (isEven ? DINGY_GRAY : GRAY)};
    box-shadow: 0px 0px 2px 0px ${({ isEven }) => (isEven ? DINGY_GRAY : GRAY)},
      0px 0px 2px 2px ${({ isEven }) => (isEven ? DINGY_GRAY : GRAY)};

    .icon-arrowUp-extraLine {
      display: block;
      position: absolute;
      top: 42px;
      left: 443px;
      z-index: 5;
    }

    .grid-body-row-hover-extraLine {
      transition: 0.2s ease;
      background: ${DARK_GRAY};
      border-radius: 4px;
      width: 250px;
      height: 106px;
      display: flex;
      align-items: center;
      padding: 0px 10px;
      position: absolute;
      top: 65px;
      left: 340px;
      width: 217px;
      height: 85px;
      z-index: 5;

      p {
        color: ${NEAR_WHITE};
        font-size: 12px;
        line-height: 16px;
      }
    }
  }

  .grid-body-row-columns {
    display: flex;
    align-items: center;
    flex-grow: 1;
    width: calc(100% + 2px);
    min-height: ${({ rowHeight }) => `${rowHeight}px`};
    max-height: ${({ rowHeight }) => `${rowHeight}px`};
    margin-left: unset;

    > svg {
      color: ${NEAR_WHITE};
      transition: 0.2s ease;
      width: 1rem;
      margin-left: -1rem;
      font-size: 18px;
      cursor: pointer;
    }
  }

  .grid-body-row-hover {
    display: none;
  }

  .icon-arrowUp {
    display: none;
  }

  .ReactVirtualized__Table__rowColumn {
    margin: 0;
    padding: 8px;
    margin-right: 1.5rem;
    box-sizing: border-box;
    font-weight: 500;

    &:nth-child(1) {
      font-weight: bold;
      line-height: 16px;
    }
  }
`;

export const BodyCell = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: ${NEAR_WHITE};

  &,
  div {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    justify-content: center;
    overflow: hidden;
  }
`;
